import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import InvoiceV1NewEditSection from "invoice/new/InvoiceV1NewEditSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

export const NewInvoiceApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InvoiceV1NewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <InvoiceV1NewEditSection />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{ text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
};

export default NewInvoiceApp;
